import React from 'react';
import PropTypes from 'prop-types';

const SoftPOS = ({ fill = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.96616 6.16264C3.45425 6.39132 3.23563 6.99241 3.3773 7.53488C3.50193 8.01206 3.56698 8.50418 3.56998 9C3.5742 9.51968 3.50934 10.0361 3.37822 10.5359C3.23618 11.0774 3.45124 11.6782 3.96079 11.91C4.46381 12.1389 5.06438 11.9231 5.23539 11.3976C5.48904 10.6181 5.61865 9.80138 5.61748 8.9775C5.60605 8.19354 5.47597 7.41777 5.23327 6.67618C5.06255 6.15453 4.46731 5.93876 3.96616 6.16264Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      d="M12.3369 2.31152C11.8136 2.55616 11.6027 3.18618 11.8293 3.71752C12.5409 5.38593 12.9236 7.17973 12.9525 9C12.9185 10.8427 12.5301 12.6583 11.8119 14.3488C11.5916 14.8673 11.7926 15.4807 12.2985 15.7285C12.791 15.9696 13.389 15.7737 13.6103 15.272C14.4817 13.2965 14.9552 11.1651 15 9C14.9687 6.85338 14.5062 4.73838 13.6436 2.77966C13.4236 2.28003 12.8314 2.08033 12.3369 2.31152Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      d="M8.10659 4.17825C7.59995 4.42109 7.39541 5.03055 7.59425 5.55601C8.03046 6.70878 8.25372 7.93426 8.25 9.1725C8.27082 10.3137 8.05945 11.4436 7.63259 12.4949C7.4262 13.0031 7.5905 13.6054 8.06731 13.8767C8.55209 14.1525 9.17363 13.9815 9.39627 13.4701C9.98463 12.1187 10.2807 10.654 10.26 9.1725C10.269 7.62218 9.97742 6.08803 9.40489 4.65395C9.20111 4.14349 8.60222 3.94067 8.10659 4.17825Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
  </svg>
);

SoftPOS.propTypes = {
  fill: PropTypes.string,
};

export default SoftPOS;
